<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="优惠券名称" prop="name">
                <a-input v-model="queryParam.name" placeholder="请输入优惠券名称" allow-clear/>
              </a-form-item>
            </a-col>

            <template v-if="advanced">

            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['coupon:coupon:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" @click="$refs.distributeForm.handleOpen()" v-hasPermi="['coupon:coupon:distribute']">
          <a-icon type="gift" />发放优惠券
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['coupon:coupon:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['coupon:coupon:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <distribute-form
        ref="distributeForm"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="effectiveDisplay" slot-scope="text, record">
          {{ formatValidity(record) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['coupon:coupon:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['coupon:coupon:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['coupon:coupon:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageCoupon, delCoupon } from '@/api/coupon/coupon'
import CreateForm from './modules/CreateForm'
import DistributeForm from './modules/DistributeForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Coupon',
  components: {
    CreateForm,
    DistributeForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        name: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          width: 80,
          align: 'center',
          customRender: (text, record, index) => index + 1
        },
        {
          title: '优惠券名称',
          dataIndex: 'name',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '优惠券满额',
          dataIndex: 'require',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '优惠券金额',
          dataIndex: 'price',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '有效时间',
          dataIndex: 'expiryType',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'effectiveDisplay' }
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询优惠券列表 */
    getList () {
      this.loading = true
      pageCoupon(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
      }).finally(() => {
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        name: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    formatValidity (record) {
      if (!record) {
        return '-'
      }
      if (Number(record.expiryType) === 1) {
        const start = record.validityStart ? this.parseTime(record.validityStart) || record.validityStart : '-'
        const end = record.validityEnd ? this.parseTime(record.validityEnd) || record.validityEnd : '-'
        return `固定: ${start}~${end}`
      }
      if (Number(record.expiryType) === 2) {
        return record.effective !== null && record.effective !== undefined ? `领取后 ${record.effective} 天` : '-'
      }
      return '-'
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row && row.id ? [row.id] : this.ids.slice()
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids.join(',') + '的数据',
        onOk () {
          const data = ids.map(id => ({ id }))
          return delCoupon(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          that.onSelectChange([], [])
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('coupon/coupon/export', {
            ...that.queryParam
          }, `优惠券_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
